import { useEffect, useState } from "react";

const MEV_ENDPOINT =
  "https://us-central1-leadershipplatform-158316.cloudfunctions.net/m110-getmevprice";

export default function MEVPrice() {
  const [price, setPrice] = useState(null);

  useEffect(() => {
    const fetchPrice = async () => {
      const res = await fetch(MEV_ENDPOINT);
      const data = await res.json();
      if (data.success) setPrice(data.MEVprice);
    };

    fetchPrice();
    const interval = setInterval(fetchPrice, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <span>
      {/* MEV: {price ? `$${price.toFixed(5)}` : "Loading..."} */}
      {price !== null ? `${Number(price).toFixed(2)} USD` : "Loading..."}
    </span>
  );
}

